import { createColumnHelper } from '@tanstack/react-table';
import cn from 'classnames';
import { CheckCircle } from '#assets/ReactSvg.ts';
import { Timestamp } from '#components/atoms/timestamp/Timestamp.tsx';
import { Table } from '#components/patterns/table/Table.tsx';
import type { CertificateAuthority } from '#dn-types/certificate-authority.ts';

type Props = {
  data: CertificateAuthority[];
  isFetching: boolean;
};

const columnHelper = createColumnHelper<CertificateAuthority>();

const columns = [
  columnHelper.accessor('fingerprint', {
    header: 'Fingerprint',
    size: 200,
    meta: {
      truncate: true,
    },
  }),
  columnHelper.accessor('notBefore', {
    header: 'Not Before',
    size: 150,
    cell(info) {
      return <Timestamp datetime={info.getValue()} />;
    },
    meta: {
      truncate: true,
    },
  }),
  columnHelper.accessor('notAfter', {
    header: 'Not After',
    size: 150,
    cell(info) {
      return <Timestamp datetime={info.getValue()} />;
    },
    meta: {
      truncate: true,
    },
  }),
  columnHelper.accessor('signingForNetworkID', {
    header: 'Is Signing CA',
    size: 100,
    cell(info) {
      const value = info.getValue();
      if (value) {
        return (
          <>
            <CheckCircle
              height={16}
              width={16}
              title="This CA is currently signing hosts"
              aria-hidden="true"
              aria-describedby="is-signing-ca"
            />
            <span id="is-signing-ca" className="visually-hidden">
              This CA is currently signing hosts
            </span>
          </>
        );
      }
      return null;
    },
  }),
];

export function CertificateAuthoritiesList({ data, isFetching }: Props) {
  return <Table data={data} columns={columns} className={cn({ 'opacity-dim': isFetching })} />;
}
